<template>
  <div
    class="building-comfy"
  >
    <a-row
      type="flex"
      align="bottom"
    >
      <a-col :span="24">
        <label>{{ $t('settings.building.comfyInstallation') }}</label>
      </a-col>
      <a-col :span="3">
        <HKLRadioButton
          v-model="internalValue"
          :value="true"
          :disabled="!isEdit"
          name="comfyInstallation"
        >
          {{ $t('action.yes') }}
        </HKLRadioButton>
      </a-col>
      <a-col :span="3">
        <HKLRadioButton
          v-model="internalValue"
          :value="false"
          :disabled="!isEdit"
          name="comfyInstallation"
        >
          {{ $t('action.no') }}
        </HKLRadioButton>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { computed } from 'vue-demi'
import HKLRadioButton from '@/controls/Button/HKLRadioButton.vue'
import { useRouteQuery } from '@/router/useRouter'

export default {
  components: {
    HKLRadioButton,
  },
  props: {
    value: {
      type: Boolean,
      default: true,
    },
  },
  setup (props, { emit }) {
    const isEdit = useRouteQuery('isEdit')
    const internalValue = computed({
      set (newValue) {
        emit('input', newValue)
      },
      get () {
        return props.value
      },
    })
    return {
      isEdit,
      internalValue,
    }
  },
}
</script>

<style lang="scss" scoped>
.building-comfy {
  label {
    margin: 0;
  }
}
</style>
